<template>
  <select
    v-model="currentValue"
    class="HeadingPicker"
  >
    <option
      value="p"
      v-text="$t('HeadingPicker.Paragraph')"
    ></option>
    <option
      value="h1"
      v-text="$t('HeadingPicker.Heading1')"
    ></option>
    <option
      value="h2"
      v-text="$t('HeadingPicker.Heading2')"
    ></option>
    <option
      value="h3"
      v-text="$t('HeadingPicker.Heading3')"
    ></option>
    <option
      value="h4"
      v-text="$t('HeadingPicker.Heading4')"
    ></option>
    <option
      value="h5"
      v-text="$t('HeadingPicker.Heading5')"
    ></option>
  </select>
</template>

<script>
import useI18n from '@/modules/i18n/mixins/useI18n.js';

export default {
  mixins: [useI18n],

  props: {
    editor: {
      type: Object,
      required: true,
    },
  },

  computed: {
    currentValue: {
      get() {
        if (this.editor.isActive('paragraph')) {
          return 'p';
        }

        if (this.editor.isActive('heading', { level: 1 })) {
          return 'h1';
        }
        if (this.editor.isActive('heading', { level: 2 })) {
          return 'h2';
        }
        if (this.editor.isActive('heading', { level: 3 })) {
          return 'h3';
        }
        if (this.editor.isActive('heading', { level: 4 })) {
          return 'h4';
        }
        if (this.editor.isActive('heading', { level: 5 })) {
          return 'h5';
        }

        return null;
      },

      set(newValue) {
        if (newValue == 'p') {
          this.editor.chain().focus().setParagraph().run();
          return;
        }

        if (newValue[0] == 'h') {
          const level = parseInt(newValue.substring(1));
          this.editor.chain().focus().setHeading({ level }).run();
        }
      },
    },
  },

  i18n: {
    en: {
      'HeadingPicker.Heading1': 'Heading 1',
      'HeadingPicker.Heading2': 'Heading 2',
      'HeadingPicker.Heading3': 'Heading 3',
      'HeadingPicker.Heading4': 'Heading 4',
      'HeadingPicker.Heading5': 'Heading 5',
      'HeadingPicker.Paragraph': 'Paragraph',
    },
    es: {
      'HeadingPicker.Heading1': 'Encabezado 1',
      'HeadingPicker.Heading2': 'Encabezado 2',
      'HeadingPicker.Heading3': 'Encabezado 3',
      'HeadingPicker.Heading4': 'Encabezado 4',
      'HeadingPicker.Heading5': 'Encabezado 5',
      'HeadingPicker.Paragraph': 'Párrafo',
    },
    de: {
      'HeadingPicker.Heading1': 'Überschrift 1',
      'HeadingPicker.Heading2': 'Überschrift 2',
      'HeadingPicker.Heading3': 'Überschrift 3',
      'HeadingPicker.Heading4': 'Überschrift 4',
      'HeadingPicker.Heading5': 'Überschrift 5',
      'HeadingPicker.Paragraph': 'Absatz',
    },
  },
};
</script>

<style lang="scss">
.HeadingPicker {
  background: transparent;
  font-size: inherit;
  font-family: inherit;
  padding: 6px 8px;

  border: 1px solid #dedede;
  border-radius: 4px;
  margin-right: 4px;
}
</style>